export class Remittance {
  constructor(objInit) {
    this.id = objInit.id;
    this.attachments = objInit.attachments;
    this.createdAt = objInit.createdAt;
    this.email = objInit.email;
    this.invoices = objInit.invoices;
    this.isValid = objInit.isValid;
    this.localTotalAmount = objInit.localTotalAmount;
    this.modifiedAt = objInit.modifiedAt;
    this.payeeName = objInit.payeeName;
    this.payerName = objInit.payerName;
    this.paymentDate = objInit.paymentDate;
    this.paymentMethod = objInit.paymentMethod;
    this.populated = objInit.populated;
    this.rawEmail = objInit.rawEmail;
    this.source = objInit.source;
    this.summary = objInit.summary;
    this.totalAmount = objInit.totalAmount;
    this.totalAmountCurrency = objInit.totalAmountCurrency;
    this.transactions = objInit.transactions;
    this.transactionIds = objInit.transactionIds;
    this.customerId = objInit.customerId;
    this.customerName = objInit.customerName;
  }
}
